import type { ReactNode } from 'react';
import { openLink, splitLinks } from '../../lib/linkify.js';
import { openStore, splitStoreLinks } from '../../lib/storeLinks.js';

/** Um pedaço de texto com os endereços virando toque (abrem no navegador). */
export function Linked({ text }: { text: string }): ReactNode {
  const parts = splitLinks(text);
  if (parts.length === 1 && !parts[0]!.url) return text;
  return parts.map((part, index) =>
    part.url ? (
      <a
        key={index}
        className="turn-link"
        href={part.url}
        rel="noopener noreferrer"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          openLink(part.url!);
        }}
      >
        {part.text}
      </a>
    ) : (
      <span key={index}>{part.text}</span>
    ),
  );
}

/**
 * Texto de uma fala da conversa: os links da loja (aviso de versão nova) abrem a
 * atualização; qualquer outro endereço vira toque e abre no navegador.
 */
export function TurnText({ text, className }: { text: string; className?: string }) {
  // Lista na resposta ("- item" em cada linha): vira lista de verdade, sem o hífen à mostra.
  if (/^[ \t]*-[ \t]+\S/m.test(text)) {
    const lines = text.replace(/\n{3,}/g, '\n\n').split('\n');
    return (
      <p className={className}>
        {lines.map((line, index) => {
          const item = line.match(/^[ \t]*-[ \t]+(.*)$/);
          if (item)
            return (
              <span key={index} className="turn-li">
                <Linked text={item[1]!} />
              </span>
            );
          if (!line.trim()) return <span key={index} className="turn-gap" aria-hidden="true" />;
          return (
            <span key={index} className="turn-line">
              <Linked text={line} />
            </span>
          );
        })}
      </p>
    );
  }
  const parts = splitStoreLinks(text);
  return (
    <p className={className}>
      {parts.map((part, index) =>
        part.url ? (
          <a
            key={index}
            className="turn-link"
            href={part.url}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              void openStore(part.url);
            }}
          >
            {part.text}
          </a>
        ) : (
          <Linked key={index} text={part.text} />
        ),
      )}
    </p>
  );
}
